export default "__VITE_ASSET__BzmoHOcQ__"